module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-123.bb4b724.woff2";